<template>
  <div class="container max-w-full mx-auto md:py-6 px-6 text-gray-800">
    <div class="max-w-xl mx-auto">
      <div class="relative">
        <div class="flex flex-wrap">
          <div class="mt-3">
            <h1 class="text-4xl mb-1 font-bold">Acesse sua conta</h1>
            <small>Informe os dados de acesso</small>
          </div>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            method="post"
            class="mt-6"
            @submit.prevent="handleSubmit(login)"
          >
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <input-icon
                :icon="{ name: 'envelope', type: 'regular' }"
                id="email"
                name="email"
                type="email"
                label="E-mail:"
                v-model="email"
              ></input-icon>
              <span v-if="errors.length" class="block text-red-600 mb-5">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input-icon
                :icon="{ name: 'lock' }"
                id="password"
                name="password"
                type="password"
                label="Password:"
                v-model="password"
              ></input-icon>
              <span v-if="errors.length" class="block text-red-600 mb-5">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <div class="flex flex-col xs:flex-col sm:flex-col md:flex-row items-center">
              <button-icon
                text="Acessar Conta"
                icon="right-arrow-alt"
                class="lg:flex-1 bg-primary hover:bg-indigo-400 mb-1 my-4"
              ></button-icon>
              <router-link
                to="/auth/recuperar-senha"
                class="lg:ml-0 my-4 text-lg md:px-6"
                >Recuperar senha</router-link
              >
            </div>
            <div class="flex-glow w-full mt-8 text-right pb-4 border-t py-5">
              <router-link to="/auth/criar-conta" class="my-4 mb-3  text-lg"
                >Você ainda não tem conta?
                <span class="text-indigo-600 font-bold"
                  >Cria nova conta</span
                ></router-link
              >
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('email', email)

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('email', {
  ...email,
  message: 'Endereço de e-mail não é valido'
})
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login() {
      const data = {
        email: this.email,
        password: this.password
      }
      this.$store
        .dispatch('doLogin', data)
        .then(response => {
          this.$gtag.event('login', { method: 'email' })
          this.$toasted.success('Logado com sucesso!', {
            position: 'top-center',
            duration: 5000,
            icon: 'check'
          })

          if (!response.data.data.user.store_id) {
            this.$router.push({ name: 'store.create' })
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            this.$toasted.error('Dados de acesso Inválidos!', {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          }
          this.$store.dispatch('loadingFail')
        })
    }
  }
}
</script>

<style></style>
